export const canResumeIntake = (decision) => ["draft", "composing"].includes(decision?.status);
export const intakeUrl = (id) => `/keputusan/baru?${new URLSearchParams({ draft: id })}`;
